import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
//5889
import { TextField } from "formik-mui";
import { Field, useFormikContext } from "formik";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { LocalizationProvider } from "@material-ui/pickers";
//5890
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// import MomentUtils from "@date-io/moment";
import propTypes from "prop-types";
import moment from "moment";

import MoreInfo from "../MaterialComponents/MoreInfo";
import SelectMenu from "../MaterialComponents/SelectMenu";

const LumenPanelData = ({ panelistRolesTypes, panelTypes }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" component={"span"}>
            Please define how to assign the panelists when the study goes live
          </Typography>
        </Grid>

        <Grid container wrap="nowrap" item xs={12}>
          <SelectMenu
            // name="quick_task_data.panelist_role_id"
            name="quick_task_data.panelist_role"
            label="Panelist role id"
            options={panelistRolesTypes}
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="Type of panelist assigned to this task"
          />
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <SelectMenu
            name="quick_task_data.panel_id"
            label="Panel ID"
            options={panelTypes}
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="Assign to desktop or mobile panel"
          />
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <Field
            fullWidth
            multiline
            name="quick_task_data.short_description"
            component={TextField}
            label="Short description"
            variant="filled"
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="Description of the dates when it is supposed to go live"
          />
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <Field
            fullWidth
            name="quick_task_data.reward"
            component={TextField}
            label="Reward"
            variant="filled"
          />
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="What the panelist gets for completing the task (typically 100)"
          />
        </Grid>

        <Grid container wrap="nowrap" item xs={12}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
              // inputVariant="filled"
              slotProps={{ textField: { fullWidth: true, variant: "filled" } }}
              value={
                values.quick_task_data.start_date == null
                  ? null
                    : moment(values.quick_task_data.start_date)
              }
              onChange={(time) => {
                if (typeof time === "object") {
                  setFieldValue(
                    "quick_task_data.start_date",
                    time.format("YYYY-MM-DD HH:mm:ss")
                  );
                }
              }}
              // component={DateTimePicker}
              label="Start date"
              name="quick_task_data.start_date"
            />
          </LocalizationProvider>
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="When the task goes live"
          />
        </Grid>
        <Grid container wrap="nowrap" item xs={12}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
              // inputVariant="filled"
              slotProps={{ textField: { fullWidth: true, variant: "filled" } }}
              value={
                values.quick_task_data.expiry_date == null
                  ? null
                  : moment(values.quick_task_data.expiry_date)
              }
              onChange={(time) => {
                if (typeof time === "object") {
                  setFieldValue(
                    "quick_task_data.expiry_date",
                    time.format("YYYY-MM-DD HH:mm:ss")
                  );
                }
              }}
              // component={DateTimePicker}
              label="End date"
              name="expiry_date"
            />
          </LocalizationProvider>
          <MoreInfo
            outerContainerClassName="moreInfo"
            popup="When the task ends"
          />
        </Grid>
      </Grid>
    </>
  );
};

LumenPanelData.propTypes = {
  panelistRolesTypes: propTypes.object,
  panelTypes: propTypes.object,
};

export default LumenPanelData;
